import { GenderEnum } from './enums/gender.enum';

export const genderList = [
  { id: GenderEnum.Male, name: 'Мужчина' },
  { id: GenderEnum.Female, name: 'Женщина' },
];
